import React, { useRef, useState, useEffect } from "react";
import { BottomBar, Button, Container, Pagination, ResponsiveFields, Searchbox, AddGuest, EditPassport, EditNationalId, Toast, Dialog } from "../../../../../Components";
import useFetch from "../../../../../Hooks/useFetch";
import apis from "../../../../../Utils/apis";
import { StampToDate } from "../../../../../Utils/utils";
import { deleteRequest } from "../../../../../Utils/axios";
import { FaTrashAlt } from "react-icons/fa";

function Guests() {
	const initial = { guests: [], count: 0, pages: 0 };
	const [Query, setQuery] = useState({ search: "", page: 1 });
	const { response, reload, loading } = useFetch(apis.getAllGuests, Query, initial);
	const [ConfirmDialog, setConfirmDialog] = useState();
	const listTopRef = useRef(null);
	const totalCount = Number(response.count) || 0;
	const totalPages = Math.max(1, Number(response.pages) || 1);
	const currentPage = Math.min(Math.max(Query.page, 1), totalPages);

	useEffect(() => {
		if (listTopRef.current) {
			listTopRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	}, [Query.page]);

	const deleteGuest = () => {
		deleteRequest(`guests/${ConfirmDialog.id}`, {}, (r, e) => {
			if (r) {
				Toast.success(`Guest deleted`);
				setConfirmDialog();
				reload();
			} else if (e) {
				Toast.handleError(e);
			}
		});
	};

	return (
		<>
			<BottomBar>
				<div className="flex flex-col w-full gap-1.5">
					<div className="flex items-end justify-between gap-2">
						<div className="align-center gap-x-4">
							<AddGuest onReload={reload} />
							<h5 className="leading-tight">{totalCount} Guests</h5>
						</div>
						<div className="text-xs text-secondary whitespace-nowrap">Page {currentPage} of {totalPages}</div>
					</div>
					<Pagination showNumbers={false} active={currentPage} total={totalPages} onChange={(page) => setQuery({ ...Query, page })} />
				</div>
			</BottomBar>
			<div ref={listTopRef} className="mt-6 flex w-full">
				<Searchbox className="w-full sm:w-96" placeholder="Search Guests" cmd="s" onChange={(search) => setQuery({ ...Query, search, page: 1 })} />
			</div>
			<Container variant="outlined" className="mt-4 mb-20 !p-2 sm:!p-4">
				{loading ? (
					<div className="p-4 text-sm text-secondary">Loading...</div>
				) : (
					<ResponsiveFields
						variant="cards"
						columnsClassName="sm:grid-cols-2 lg:grid-cols-3"
						items={response.guests || []}
						getKey={(g, i) => `${g?.id || ""}-${i}`}
						columns={[
							{ key: "name", label: "Guest Name", valueClassName: "font-bold break-words", render: (g) => `${g.fName} ${g.lName}` },
							{ key: "email", label: "Email", valueClassName: "break-words", render: (g) => g.email || "-" },
							{ key: "phone", label: "Phone", valueClassName: "whitespace-nowrap", render: (g) => g.phone || "-" },
							{ key: "gender", label: "Gender", valueClassName: "whitespace-nowrap", render: (g) => g.gender || "-" },
							{ key: "dob", label: "Date of Birth", valueClassName: "whitespace-nowrap", render: (g) => (g.dob ? StampToDate(g.dob) : "-") },
							{
								key: "passport",
								label: "Passport",
								render: (g) => <EditPassport reload={reload} identification={g.identification} guestId={g.id} photo={g.photo} />,
							},
							{
								key: "nationalId",
								label: "National ID",
								render: (g) => <EditNationalId reload={reload} identification={g.identification} guestId={g.id} />,
							},
							{
								key: "actions",
								label: "Actions",
								render: (g) => (
									<Button onClick={() => setConfirmDialog(g)} variant="danger" className="btn-xs w-full sm:w-auto">
										<FaTrashAlt />
									</Button>
								),
							},
						]}
					/>
				)}
			</Container>
			<Dialog variant="danger" open={ConfirmDialog} title="Delete Guest" description="Are you sure you want to delete this guest, this is an irreversible action." submitLabel="Delete" onSubmit={deleteGuest} onClose={setConfirmDialog} />
		</>
	);
}

export default Guests;
